module.exports = __webpack_public_path__ + "preview-eac7acfc/open-sans-hebrew-bold-5ef117b3d8e874a8b93bbc7536e594a8.ttf";